<template>
  <div class="footer">
    <div class="text-container" id="indexFoot"></div>
  </div>
</template>

<script>
import { searchInfo } from "@/api/complaint";

export default {
  data() {
    return {

    };
  },
  //初始化下拉框数据
  mounted() {
    this.searchInfo();
  },
  methods: {
    //基本信息
    searchInfo() {
      document.getElementById('indexFoot').innerHTML="望海康信（北京）科技股份公司版权所有©2020";
      searchInfo()
        .then((response) => {
          var search = response.data;
          if(search!=null) {
            // 文本数组
            let texts = ["望海康信（北京）科技股份公司版权所有©2020", search.orgName + " （联系电话：" + search.linkPhone + "）"];
            let currentIndex = 0;
            // 更新文本函数
            let ut=function updateText(){
               document.getElementById('indexFoot').innerHTML = texts[currentIndex];
              if(texts.length>1) {
                currentIndex = (currentIndex + 1) % texts.length;
              }
            };
            // 设置定时器
            setInterval(ut, 5000); // 每5秒更新一次文本
          }
        })
        .catch(function (err) {});
    }

  }

};
</script>
<style>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  background: rgba(102, 102, 102, 1);
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  z-index: 999;
}
.text-container {
  text-align: center;
  animation: fade-in-out 5s infinite alternate;
}
@keyframes fade-in-out {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue